import { getProfileBlockit } from "@/api/profile";
import { GROUP_ID } from "@/constant/group";
import { useCurrentUser } from "@/provider/currentUser";
import {
  AppBar,
  NativeEmojiSafeText,
  ShavedText,
  shaveWalletAddress,
  UserProfileImage,
} from "@moim/common";
import * as React from "react";
import ProfileHeader from "./components/profileHeader";
import { ProfileBlockRenderer } from "./renderer";
import {
  AppBarStickyWrapperStyle,
  AppBarTitleUsername,
  AppBarTitleWrapper,
  AppBarWrapperStyle,
  BioWrapper,
  Body,
  getAppBarStickyStyle,
  ParallaxUsername,
  ParallaxUsernameWrapper,
  ParallaxWrapper,
  Section,
  UserBio,
  UserWalletAddress,
  Wrapper,
} from "./styledComponent";

const ProfilePage = () => {
  const { currentUser } = useCurrentUser();

  const [userProfileBlocks, setUserProfileBlocks] = React.useState<
    Moim.Blockit.Blocks[]
  >([]);

  const getUserBlock = React.useCallback(async () => {
    if (currentUser) {
      const blockData = await getProfileBlockit(
        GROUP_ID,
        currentUser.id,
        "show",
      );

      setUserProfileBlocks(blockData);
    }
  }, [currentUser?.id]);

  React.useEffect(() => {
    getUserBlock();
  }, [currentUser?.id]);

  if (!currentUser) {
    return null;
  }

  return (
    <Wrapper>
      <AppBar
        wrapperStickyStyle={getAppBarStickyStyle(0, AppBarStickyWrapperStyle)}
        wrapperStyle={AppBarWrapperStyle}
        leftButton={null}
        rightButton={null}
        titleElement={
          <AppBarTitleWrapper>
            <UserProfileImage
              userId={currentUser?.id}
              size="xs"
              src={currentUser?.avatar_url || ""}
              isOnline={currentUser?.presence === "ACTIVE"}
            />
            <AppBarTitleUsername>
              <NativeEmojiSafeText value={currentUser?.name ?? ""} />
            </AppBarTitleUsername>
          </AppBarTitleWrapper>
        }
        titleAlignment="Left"
        enableScrollParallax={true}
        parallaxWrapperComponent={ParallaxWrapper}
        titleContainerDisappearPosition={20}
        parallaxDisappearPosition={110}
        expendScrollParallaxElement={[
          <ProfileHeader
            type="show"
            userId={currentUser?.id ?? ""}
            avatar={currentUser?.avatar_url || ""}
            isOnline={currentUser?.presence === "ACTIVE"}
          />,
          <ParallaxUsernameWrapper>
            <ParallaxUsername>
              <ShavedText
                value={<NativeEmojiSafeText value={currentUser?.name ?? ""} />}
                line={2}
              />
            </ParallaxUsername>
          </ParallaxUsernameWrapper>,
        ]}
      />
      <Body>
        {currentUser?.metamask &&
        userProfileBlocks?.find(
          (block: any) => block.type === "metamask-address",
        ) ? (
          <UserWalletAddress>
            {shaveWalletAddress(currentUser.metamask)}
          </UserWalletAddress>
        ) : null}
        {currentUser?.bio ? (
          <Section>
            <BioWrapper>
              <UserBio>
                <NativeEmojiSafeText value={currentUser.bio} />
              </UserBio>
            </BioWrapper>
          </Section>
        ) : null}
        <ProfileBlockRenderer
          blocks={userProfileBlocks}
          isMine
          positions={
            (currentUser as unknown as Moim.User.IOriginalUserDatum).positions
          }
          userData={currentUser as unknown as Moim.User.IOriginalUserDatum}
        />
      </Body>
    </Wrapper>
  );
};

export default ProfilePage;
